import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    AfterViewInit,
    ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
// -- libs --
import { CarouselModule, Carousel } from 'primeng/carousel';
import { MatIconModule } from '@angular/material/icon';
// -- components --
import { SuccessStoryItemComponent } from './components/success-story-item/success-story-item.component';
import { MobileSmeStoriesComponent } from './components/mobile-sme-stories/mobile-sme-stories.component';
import { SuccessStoryModalComponent } from './components/success-story-modal/success-story-modal.component';
// -- interfaces --
import {
    SuccessStoriesResponse,
    SuccessConfResponse,
    TransformedStory,
} from './interfaces/success-story.interface';

@Component({
    selector: 'app-jc3-block-5',
    standalone: true,
    imports: [
        CommonModule,
        CarouselModule,
        MatIconModule,
        SuccessStoryItemComponent,
        MobileSmeStoriesComponent,
        SuccessStoryModalComponent,
    ],
    templateUrl: './jc3-block-5.component.html',
    styleUrl: './jc3-block-5.component.scss',
})
export class Jc3Block5Component implements OnChanges, AfterViewInit {
    @Input() successStoriesData: SuccessStoriesResponse | any = null;
    @Input() successConfData: any = null;
    @ViewChild('carousel') carousel!: Carousel;

    isMobile = window.innerWidth < 768;
    isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
    isDeskTop = window.innerWidth > 1024;

    isModalVisible = false;
    selectedStory: TransformedStory | null = null;
    smeSuccessStories: TransformedStory[] = [];
    sectionTitle = 'SME Success Stories';
    currentCarouselIndex = 0;

    getImageCardUrl(story: any) {
        if (this.isDeskTop) {
            return story?.desktopcard_url ?? '';
        } else if (this.isMobile) {
            return story?.mobilecard_url ?? '';
        } else if (this.isTablet) {
            return story?.portraitcard_url ?? '';
        } else {
            return '';
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['successStoriesData'] || changes['successConfData']) {
            this.smeSuccessStories =
                changes.successStoriesData.currentValue?.map((story) => ({
                    image:
                        story?.desktopcard_url ||
                        story?.mediaFileStores?.at(0)?.s3url,
                    pImage: story?.portraitcard_url || story?.desktopcard_url,
                    mImage: story?.mobilecard_url || story?.desktopcard_url,
                    aImageDesktop: story?.articlephotodesktop_url,
                    aImagePortrait:
                        story?.articlephotoportrait_url ||
                        story?.articlephotodesktop_url,
                    aImageMobile:
                        story?.articlephotomobile_url ||
                        story?.articlephotodesktop_url,
                    title: story?.thumbnailtitle || story.articletitle,
                    articleTitle: story.articletitle || story?.thumbnailtitle,
                    description:
                        story?.description ||
                        story.thumbnailcampaigndescription,
                    originalData: story,
                    shortdesc:
                        story?.thumbnailcampaigndescription ||
                        story?.description,
                }));
        }
    }

    openModal(story: TransformedStory) {
        this.selectedStory = story;
        this.isModalVisible = true;
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';
    }

    closeModal() {
        this.isModalVisible = false;
        this.selectedStory = null;
        // Restore body scroll when modal is closed
        document.body.style.overflow = 'auto';
    }

    ngAfterViewInit() {
        // Component initialized
    }

    onCarouselPageChange(event: any): void {
        this.currentCarouselIndex = event.page;
    }

    goToNext(): void {
        if (this.carousel && this.smeSuccessStories.length > 1) {
            this.carousel.navForward(new MouseEvent('click'));
        }
    }
}
